



import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ✅ import from index files
import en from "./locales/en";
import ar from "./locales/ar";
import rar from "./locales/rar";
import ren from "./locales/ren";
import webar from "./locales/webar"
import weben from "./locales/weben"
import resOffar from "./locales/resOffar";
import resOffen from "./locales/resOffen";
const resources = {
  en: {
    translation: {
    ...en,
    ...ren,
    ...weben,
    ...resOffen,
    }
  },
  ar: {
    translation: {
    ...ar,
    ...rar,
    ...webar,
    ...resOffar,
    }
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("i18nextLng") || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  supportedLngs: ["en", "ar"],
  load: "languageOnly",
});

export default i18n;